import { useColorMode } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import logos from '../images/logos';
import { IBetSplit, IObject } from '../types/bet-split';

export default function useGetBetSplitData(
    token: string,
    internalId: string,
    page: number = 1,
    timePlacedStart?: string
) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const colorMode = useColorMode();
    const logosWithTheme = logos[colorMode.colorMode];

    const [result, setResult] = useState<IBetSplit | null>(null);

    useEffect(() => {
        setResult(null);
    }, [timePlacedStart]);

    useEffect(
        function () {
            const controller = new AbortController();
            const signal = controller.signal;

            (async function () {
                if (result?.totalPages && page > result?.totalPages) return;
                setLoading(true);

                const baseURL = `${
                    process.env.REACT_APP_API_BASE || ''
                }/v1/bettors/${internalId}/betSlips?bestPrice=true&pageSize=10&pageNum=${page}`;

                try {
                    const betSplitJSONPromise = await fetch(
                        `${baseURL}${
                            timePlacedStart
                                ? `&timePlacedStart=${timePlacedStart}`
                                : ''
                        }`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: token,
                            },
                            signal,
                        }
                    );

                    const betSplitJSON = await betSplitJSONPromise.json();
                    betSplitJSON.objects.forEach((object: IObject) => {
                        object.book.logo = logosWithTheme[object.book.abbr];
                    });

                    setResult((result) => ({
                        ...betSplitJSON,
                        objects: [
                            ...(result?.objects || []),
                            ...betSplitJSON.objects,
                        ],
                    }));
                } catch (error) {
                    setError(error as string);
                } finally {
                    setLoading(false);
                }
            })();

            return () => controller.abort();
        },
        [page, timePlacedStart]
    );

    return { loading, result, error };
}
